import { render, staticRenderFns } from "./UserInfos.vue?vue&type=template&id=2c6d412b&scoped=true&"
import script from "./UserInfos.vue?vue&type=script&lang=js&"
export * from "./UserInfos.vue?vue&type=script&lang=js&"
import style0 from "./UserInfos.vue?vue&type=style&index=0&id=2c6d412b&prod&lang=sass&"
import style1 from "./UserInfos.vue?vue&type=style&index=1&id=2c6d412b&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6d412b",
  null
  
)

export default component.exports